import { format, addYears, startOfYear, addMonths } from 'date-fns'

// Note for beneficiaries, the fiscal year starts in July (Partner is given a month).
/* export const getFiscalYearTimestamps = () => {
  const currentMonth = format(new Date(), 'MM')

  if (parseInt(currentMonth, 0) < 6) {
    return {
      current: {
        start: format(
          addMonths(startOfYear(addYears(new Date(), -1)), 6),
          'yyyy-MM-dd',
        ),
        end: format(addMonths(endOfYear(new Date()), -6), 'yyyy-MM-dd'),
        year: format(new Date(), 'yyyy'),
      },
      last: {
        start: format(
          addMonths(startOfYear(addYears(new Date(), -2)), 6),
          'yyyy-MM-dd',
        ),
        end: format(
          addMonths(endOfYear(addYears(new Date(), -1)), -6),
          'yyyy-MM-dd',
        ),
        year: format(addYears(new Date(), -1), 'yyyy'),
      },
      next: {
        start: format(addMonths(startOfYear(new Date()), 6), 'yyyy-MM-dd'),
        end: format(
          addMonths(endOfYear(addYears(new Date(), 1)), -6),
          'yyyy-MM-dd',
        ),
        year: format(addYears(new Date(), 1), 'yyyy'),
      },
    }
  }

  return {
    current: {
      start: format(addMonths(startOfYear(new Date()), 6), 'yyyy-MM-dd'),
      end: format(
        addMonths(endOfYear(addYears(new Date(), 1)), -6),
        'yyyy-MM-dd',
      ),
      year: format(addYears(new Date(), 1), 'yyyy'),
    },
    last: {
      start: format(
        addMonths(startOfYear(addYears(new Date(), -1)), 6),
        'yyyy-MM-dd',
      ),
      end: format(addMonths(endOfYear(new Date()), -6), 'yyyy-MM-dd'),
      year: format(new Date(), 'yyyy'),
    },
    next: {
      start: format(
        addMonths(startOfYear(addYears(new Date(), 1)), 6),
        'yyyy-MM-dd',
      ),
      end: format(
        addMonths(endOfYear(addYears(new Date(), 2)), -6),
        'yyyy-MM-dd',
      ),
      year: format(addYears(new Date(), 2), 'yyyy'),
    },
  }
} */

// Note for beneficiaries, the fiscal year starts in July (Partner is given a month to confirm - nomination process).
export function getFiscalYearTimestamps(fiscalStartMonth = 6) {
  const now = new Date()
  const currentMonth = now.getMonth() + 1 // 1-based
  const isBeforeFiscalStart = currentMonth < fiscalStartMonth

  function getFiscalDates(startYearOffset) {
    const fiscalYearStart = addMonths(startOfYear(addYears(now, startYearOffset)), fiscalStartMonth)
    const fiscalYearEnd = addMonths(addYears(fiscalYearStart, 1), -1) // end is one month before next fiscal start
    const fiscalYearLabel = format(fiscalYearEnd, 'yyyy') // Label by the year it ends

    return {
      start: format(fiscalYearStart, 'yyyy-MM-dd'),
      end: format(fiscalYearEnd, 'yyyy-MM-dd'),
      year: fiscalYearLabel,
    }
  }

  const current = getFiscalDates(isBeforeFiscalStart ? -1 : 0)
  const last = getFiscalDates(isBeforeFiscalStart ? -2 : -1)
  const next = getFiscalDates(isBeforeFiscalStart ? 0 : 1)

  return { current, last, next }
}



// WEBPACK FOOTER //
// ./src/utils/fiscalYear.js